// extracted by mini-css-extract-plugin
export var copyableField = "_pe-4";
export var customerBadge = "_pe-0";
export var customerInfoTitle = "_pe-2";
export var details = "_pe-1";
export var dropdownContainer = "_pe-5";
export var dropdownImage = "_pe-6";
export var editAssigneeForm = "_pe-a";
export var editButton = "_pe-3";
export var email = "_pe-7";
export var hidden = "_pe-d";
export var input = "_pe-8";
export var saveButton = "_pe-b";
export var shopifyIcon = "_pe-c";
export var suggestionBadge = "_pe-e";
export var suggestionText = "_pe-f";
export var username = "_pe-9";